
import BaseModel from '../../../helpers/basemodel'
import alert from '../../../helpers/alert'
import Api from '../../../helpers/api'
import moment from 'moment'

/**
 * Const
 *
 */
const api = new Api()
const TRANSTYPE = {
  SALES: `PENJUALAN`,
  SALES_RETURN: `RETUR PENJUALAN`,
  EXPENDITURE: `PEMBELIAN`,
  STOCK_OPN: `STOK OPNAME`,
  STOCK_IN: `STOK MASUK`,
  STOCK_OUT: `STOK KELUAR`,
}



/**
 * State
 *
 */
const state = {
  ...BaseModel.state,

  itemlist: [],
}


/**
 * Getters
 *
 */
const getters = {
  ...BaseModel.getters,

  data({ selectedObject: item }) {
    if (!Object.keys(item).length) return {}

    return {
      ...item,
      get date_readable() {
        if (!this.date) return ``
        return moment(this.date).format(`DD/MM/YYYY`)
      },
      get type_readable() {
        if (!this.type) return ``
        return TRANSTYPE[this.type]
      },
      get note_html() {
        if (!this.note) return ``
        return this.note.replace(`\n`, `<br>`)
      },
    }
  },

  list({ list }) {
    return list.map((item) => ({
      ...item,
      get date_readable() {
        if (!this.date) return ``
        return moment(this.date).format(`DD/MM/YYYY`)
      },
      get type_readable() {
        if (!this.type) return ``
        return TRANSTYPE[this.type]
      },
      get note_html() {
        if (!this.note) return ``
        return this.note.replace(`\n`, `<br>`)
      },
    }))
  },

  itemlist({ itemlist }) {
    return itemlist
  },
}


/**
 * Actions
 *
 */
const actions = {
  ...BaseModel.actions,

  async fetchList({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/product/transaction?` + getters.listOptions)
      .then(({ data, nrecord }) => {
        commit(`loading_mode`, 0)
        commit(`set_list`, data)
        commit(`set_nrecord`, nrecord)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchOptions({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/product/transaction?format=options`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_options`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchData({ commit }, id) {
    if (!id) return commit(`clear_selected_object`)

    commit(`loading_mode`, 1)

    return api.get(`/product/transaction/${id}`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_selected_object`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async refetchData({ dispatch }) {
    const id = state.selectedObject.id
    return dispatch(`fetchData`, id)
  },

  async fetchListItem({ commit, state }) {
    const id = state.selectedObject.id

    if (!id) return commit(`clear_listitem`)

    commit(`loading_mode`, 1)

    return api.get(`/product/transaction/${id}/item`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_listitem`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async update({ commit, dispatch, rootState }, { id, data }) {
    commit(`loading_mode`, 1)

    if (!id) id = ``

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      commit(`clear_list`)
      await dispatch(`fetchData`, result.id)

      if (id) alert.success(`Data berhasil diupdate`)
      else alert.success(`Data berhasil ditambahkan`)

      return result.id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_INVTRANSC_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.put(`/product/transaction/${id}`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async lock({ commit, dispatch, rootState }) {
    commit(`loading_mode`, 1)

    const id = state.selectedObject.id
    if (!id) return onerror()

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      commit(`clear_list`)
      await dispatch(`refetchData`)

      alert.success(`Data berhasil diupdate`)
      return id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_INVTRANSC_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.post(`/product/transaction/${id}/lock`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async remove({ commit, rootState }, id) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      commit(`clear_options`)
      // await dispatch(`fetchList`)
      alert.success(`Data berhasil dihapus`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_INVTRANSC_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.delete(`/product/transaction/${id}`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async updateListItem({ commit, dispatch, state, rootState }, data) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      commit(`clear_list`)
      await dispatch(`refetchData`)
      await dispatch(`fetchListItem`)

      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_INVTRANSC_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.put(`/product/transaction/${id}/item`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async removeListItem({ commit, dispatch, state, rootState }, data) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      commit(`clear_list`)
      await dispatch(`refetchData`)
      await dispatch(`fetchListItem`)

      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_INVTRANSC_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.delete(`/product/transaction/${id}/item`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },
}

/**
 * Mutations
 *
 */
const mutations = {
  ...BaseModel.mutations,

  set_listitem(state, list) {
    state.itemlist = list
  },

  clear_listitem(state) {
    state.itemlist = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}